import createLucideIcon from '../createLucideIcon';

const ChevronLeftSquare = createLucideIcon('ChevronLeftSquare', [
  [
    'rect',
    {
      width: '18',
      height: '18',
      x: '3',
      y: '3',
      rx: '2',
      ry: '2',
      key: '1m3agn',
    },
  ],
  ['polyline', { points: '14,16 10,12 14,8', key: '10rnk0' }],
]);

export default ChevronLeftSquare;
